import React from 'react';
import { useTranslation } from 'react-i18next';
import { CustomRequestProductConfiguration } from '@/CustomRequestProductChannel/components/CustomRequestProduct.tsx';
import {
    NegativePurchasePriceHint,
    NegativeSalesPriceHint,
    ZeroPurchasePriceHint,
    ZeroSalesPriceHint,
} from '@/shared/components/PriceInputHints.tsx';

export type CustomRequestProductHintsProps = {
    showProductPriceAddedHint?: boolean;
    showProductPriceNotAddedHint?: boolean;
    showZeroPriceProductConfiguration: boolean;
    isZeroPurchasePrice: boolean;
    isZeroSalesPrice: boolean;
    isNegativePurchasePrice: boolean;
    isNegativeSalesPrice: boolean;
    partnerOrganizationName?: string;
    orderingOrganizationName?: string;
    productConfiguration: CustomRequestProductConfiguration;
    onUpdateProductConfiguration?: (productConfiguration: Partial<CustomRequestProductConfiguration>) => void;
};

export function CustomRequestProductHints({
    isNegativePurchasePrice,
    isNegativeSalesPrice,
    isZeroSalesPrice,
    isZeroPurchasePrice,
    partnerOrganizationName,
    orderingOrganizationName,
    productConfiguration,
    onUpdateProductConfiguration,
    showProductPriceNotAddedHint,
    showProductPriceAddedHint,
    showZeroPriceProductConfiguration,
}: CustomRequestProductHintsProps) {
    const { t } = useTranslation();

    if (
        !isZeroPurchasePrice &&
        !isZeroSalesPrice &&
        !isNegativePurchasePrice &&
        !isNegativeSalesPrice &&
        !showProductPriceAddedHint &&
        !showProductPriceNotAddedHint
    ) {
        return null;
    }

    return (
        <div className="mt-4 flex flex-col gap-4">
            {showZeroPriceProductConfiguration && (
                <>
                    {isZeroPurchasePrice && (
                        <ZeroPurchasePriceHint
                            isBillingRelevant={productConfiguration.showZeroPurchasePrice}
                            partnerOrganizationName={partnerOrganizationName}
                            onClick={() =>
                                onUpdateProductConfiguration?.({
                                    showZeroPurchasePrice: !productConfiguration.showZeroPurchasePrice,
                                })
                            }
                        />
                    )}
                    {isZeroSalesPrice && (
                        <ZeroSalesPriceHint
                            orderingOrganizationName={orderingOrganizationName}
                            isBillingRelevant={productConfiguration.showZeroSalesPrice}
                            onClick={() => {
                                onUpdateProductConfiguration?.({
                                    showZeroSalesPrice: !productConfiguration.showZeroSalesPrice,
                                });
                            }}
                        />
                    )}
                </>
            )}
            {isNegativePurchasePrice && <NegativePurchasePriceHint partnerOrganizationName={partnerOrganizationName} />}
            {isNegativeSalesPrice && <NegativeSalesPriceHint orderingOrganizationName={orderingOrganizationName} />}

            {showProductPriceNotAddedHint && (
                <div className="font-copy-sm text-subdued">
                    {t('sections.productSelection.productHint.productPriceNotAdded')}
                </div>
            )}
            {showProductPriceAddedHint && (
                <div className="font-copy-sm text-subdued">
                    {t('sections.productSelection.productHint.productPriceAdded')}
                </div>
            )}
        </div>
    );
}
